import { CDN_LINK } from '@constants';

export const getImageUrl = (url: string) => `${CDN_LINK}${url}`;
